module.exports = __webpack_public_path__ + "img/placeholder.b7122921.jpg";